import axios from 'axios';
import { domain } from './domain'

export const getCompanyById = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/getbyid`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const updateCompany = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyLogo = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/logo`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyFiles = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/files`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyGallery = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/gallery`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyCertificates = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/certificates`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};